module.exports = __webpack_public_path__ + "static/img/home_icon_map.342d0769.png";